export default {"src":"/_next/static/media/simpl-inner-pdp.ac8544e6.svg","height":15,"width":42,"blurWidth":0,"blurHeight":0};